import { render, staticRenderFns } from "./PaymentArchive.vue?vue&type=template&id=4f04ee71&"
import script from "./PaymentArchive.vue?vue&type=script&lang=js&"
export * from "./PaymentArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports